export const queryStringToJson = (queryString: string): Record<string, string> => {
    const pairs = queryString.slice(1).split('&');
    const result: Record<string, string> = {};
    pairs.forEach(function (pair) {
        const [key, value] = pair.split('=');
        result[key] = decodeURIComponent(value || '');
    });

    return JSON.parse(JSON.stringify(result));
};
